<template>
  <div>
    <validation-observer
      v-show="showForm"
      ref="bookingPageRecordForm"
    >
      <template>
        <b-form
          class="p-2"
          @submit.prevent="validateRecordForm"
        >

          <!-- services select -->
          <validation-provider
            #default="{ errors }"
            :name="i18n.tc('service', 2)"
            vid="service"
            rules="required"
          >
            <label
              for="user-service"
            >
              {{ i18n.tc('service', 2) }}
              <cite
                v-if="totalTime"
                class="text-secondary font-small-1 service-time"
              >
                <b-icon
                  icon="clock"
                  size="10"
                />
                {{ i18n.t('used') }}:
                <b-badge class="light-primary time-badge">
                  {{ totalTime }}
                </b-badge>
                <span v-if="time"> / {{ i18n.t('available') }}:
                  <b-badge class="light-primary time-badge">
                    {{ stringTimeToBeautifulFormat(getCountdown) }}
                  </b-badge>
<!--                  <b-icon-->
<!--                    icon="question-circle"-->
<!--                    class="text-primary ml-1"-->
<!--                  />-->
                </span>
              </cite>
            </label>
            <b-form-group
              label-for="user-service"
              :state="errors.length > 0 ? false:null"
              :class="errors.length > 0 ? 'mb-0': ''"
            >
              <!-- service for desktop-->
              <v-select
                id="user-service"
                v-model="services"
                alt="Service selection form"
                multiple
                :close-on-select="false"
                dir="ltr"
                label="name"
                :options="showServicesThisWorkspace(workspace.id)"
                :placeholder="i18n.t('select-service')"
                :class="errors.length > 0 ? 'error-v-select' : ''"
                :selectable="(option) => option.is_available === true"
                @input="updateTimeslots"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                  <b-badge
                    size="sm"
                    pill
                    class="light-success"
                  >
                    {{ getWidgetSettings.currency }} {{ option.price}}
                  </b-badge>
                  <cite
                      class="font-small-1 service-time"
                      :class="option.is_available?'text-muted':'text-danger'"
                    >
                    <b-icon
                      icon="clock"
                      size="10"
                    />
                    <!-- TODO: отрабатывает при наведения курсора!!!! распечатать внутри функции что бы проверить -->
                    {{ stringTimeToBeautifulFormat(option.time) }}
                  </cite>
                  <br>
                  <small class="text-muted">
                    {{ option.description }}
                  </small>
                </template>
                <template #no-options>
                  {{ i18n.t('not-exist-services') }}
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Date and time -->
          <b-row>
            <!-- date -->
            <b-col cols="7">
              <validation-provider
                #default="{ errors }"
                :name="i18n.t('date')"
                vid="day"
                rules="required"
              >
                <b-form-group
                  :label="i18n.t('date')"
                  label-for="due-date"
                  :state="errors.length > 0 ? false:null"
                  :class="errors.length > 0 ? 'mb-0': ''"
                >
                  <b-dropdown
                    cols="12"
                    :text="date ? showDate : i18n.t('select-date')"
                    variant="link"
                    @show="whenOpenCalendar"
                    @hide="whenCloseCalendar"
                    block
                  >
                    <b-button variant="outline-danger" class="fix-close-button" size="sm" @click="tapCloseCalendar">
                      <b-icon
                        icon="x-lg"
                      />
                    </b-button>
                    <b-calendar
                      v-model="date"
                      :locale="locale === 'cn' ? 'zh-CN' : locale"
                      :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                      class="m-1"
                      :min="minDate"
                      :max="new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + (workspace.day_count-1))"
                      today-variant="primary"
                      start-weekday="1"
                      :date-disabled-fn="dateDisabledToCalendar"
                      @context="setShowDate"
                      @selected="changeDate"
                      label-help=""
                      hide-header
                    >
                      <template v-slot:nav-prev-year><span></span></template>
                      <template v-slot:nav-next-year><span></span></template>
                    </b-calendar>
                  </b-dropdown>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- time-->
            <b-col
              cols="5"
            >
              <validation-provider
                #default="{ errors }"
                :name="i18n.t('time')"
                vid="start_time"
                rules="required"
              >
                <b-form-group
                  :label="i18n.t('time')"
                  label-for="time"
                  :state="errors.length > 0 ? false:null"
                  :class="errors.length > 0 ? 'mb-0': ''"
                >
                  <v-select
                    id="time"
                    v-model="time"
                    :options="getDayTimeslots"
                    :placeholder="i18n.t('time')"
                    :loading="loadingTime"
                    :autoscroll="true"
                    @input="updateTimeslots"
                  >
                    <template #selected-option="option">
                      <span class="align-middle"> {{ option.label.slice(0,5) }}</span>
                    </template>
                    <template v-slot:option="option">
                      {{ option.label.slice(0,5) }}
                    </template>
                    <template #no-options>
                      {{ i18n.t('dont-have-free-time') }}
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <!-- name -->
          <validation-provider
            #default="{ errors }"
            mode="eager"
            :name="i18n.t('name')"
            vid="name"
            rules="required|max:40|textNumSpaceDash"
          >
            <b-form-group
              :class="errors.length > 0 ? 'mb-0': ''"
            >
              <label for="user-name">{{ i18n.t('name') }}</label>
              <b-form-input
                id="user-name"
                v-model="name"
                autofocus
                alt="Name entry form"
                translate="yes"
                :placeholder="i18n.t('name')"
                :state="errors.length > 0 ? false:null"
                :class="errors.length > 0 ? 'mb-0': ''"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Phone -->
          <validation-provider
            #default="{ errors }"
            mode="eager"
            vid="phone"
            :name="i18n.t('phone')"
            rules="required|likePhone"
          >
            <b-form-group
              :class="errors.length > 0 ? 'mb-0': ''"
            >
              <label for="user-phone">{{ i18n.t('phone') }}</label>
              <vue-tel-input
                id="phone"
                v-model="phone"
                :style="errors.length > 0 ? 'borderColor:#ea5455;':null"
                dir="ltr"
                mode="international"
                :input-options="{placeholder: '+123456789'}"
                :valid-characters-only="true"
                :dropdown-options="phoneDropdownOptions"
                :required="true"
                :autoDefaultCountry="!getCode"
                :defaultCountry="getCode"
                @country-changed="countryChanged"
              >
                <template slot="arrow-icon">
                  <span class="vti__dropdown-arrow">&nbsp;▼</span>
                </template>
                </vue-tel-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- email-->
          <validation-provider
            #default="{ errors }"
            mode="eager"
            :name="i18n.t('email')"
            vid="email"
            rules="required|email"
          >
            <b-form-group
              label-for="user-email"
              :class="errors.length > 0 ? 'mb-0': ''"
            >
              <label for="user-email">{{ i18n.t('email') }}</label>
              <b-form-input
                id="user-email"
                v-model="userEmail"
                alt="Email entry form"
                translate="yes"
                placeholder="example@mail.com"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- additionally-->
          <validation-provider
            #default="{ errors }"
            :name="i18n.t('additionally')"
            vid="additionally"
            rules="max:225"
          >
            <b-form-group
              label-for="additionally"
            >
              <label for="additionally">{{ i18n.t('additionally') }}</label>
              <b-form-textarea
                id="additionally"
                v-model="additionally"
                alt="Your additional message"
                translate="yes"
                rows="4"
                :placeholder="i18n.t('your-message')"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- privacy-policy-->
          <validation-provider
            #default="{ errors }"
            :name="i18n.t('approved')"
            vid="approved"
            :rules="{ required: { allowFalse: false } }"
          >
            <b-form-group>
              <b-form-checkbox
                id="register-privacy-policy"
                alt="Consent form to the terms of the privacy policy"
                translate="yes"
                v-model="approved"
                name="checkbox-1"
                :state="errors.length > 0 ? false : null"
              >
                  {{ i18n.t('i-agree') }}
                  <b-link
                    @click="openPolicy"
                    :style="{color: getWidgetSettings.main_color}"
                  >
                    {{ i18n.t('privacy-policy') }}
                  </b-link>{{ i18n.t('&') }}
                  <b-link
                    @click="openTerms"
                    :style="{color: getWidgetSettings.main_color}"
                  >
                    {{ i18n.t('terms') }}
                  </b-link>
              </b-form-checkbox>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-col align="end" class="pr-0">
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                class="buttons-effect mr-2"
                :style="`border: 1px solid ${getWidgetSettings.main_color} !important; color: ${getWidgetSettings.main_color}; background-color: transparent;`"
                size="sm"
                @click="closeModal"
              >
                {{i18n.t('back') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="buttons-effect mr-2"
                :style="{background: getWidgetSettings.main_color, borderColor: getWidgetSettings.main_color}"
                type="submit"
                :disabled="loadingSetRecord"
                size="sm"
              >
                {{ getPaymentGateway() ? i18n.t('book-and-pay') : i18n.t('book') }}
              </b-button>
            </b-col>
          </div>
        </b-form>
      </template>
    </validation-observer>
    <b-col
      v-show="!showForm"
      align="center"
    >
      <div v-if="!getErrorBookingStatus">
        <div v-if="getWidgetSettings.notification_enabled" class="swal2-icon swal2-info" style="display: flex;">
        <div class="swal2-icon-content">i</div>
        </div>
        <div v-if="!getWidgetSettings.notification_enabled" class="swal2-icon swal2-success swal2-icon-show" style="display: flex;"><div class="swal2-success-circular-line-left" style="background-color: #f8f9fa;"></div>
          <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
          <div class="swal2-success-ring"></div> <div class="swal2-success-fix" style="background-color: #f8f9fa;"></div>
          <div class="swal2-success-circular-line-right" style="background-color: #f8f9fa;"></div>
        </div>
        {{ getWidgetSettings.notification_enabled ? i18n.t('confirm-booking') : i18n.t('you-are-booked') }}<br>
        {{ getWidgetSettings.notification_enabled ? i18n.t('confirm-booking-desc') : i18n.t('booking-confirmed-desc') }} 📩
      </div>
      <ShowError v-else />
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        type="reset"
        class="queue-form-button mt-3"
        :style="`border: 1px solid ${getWidgetSettings.main_color} !important; color: ${getWidgetSettings.main_color}; background-color: transparent;`"
        size="sm"
        @click="closeModal"
      >
        Ok
      </b-button>
    </b-col>
    <b-card v-if="showPolicy || showTerms" class="queue-card-policy">
      <b-card-header>
        <b-col class="text-right">
          <b-link :style="{color: getWidgetSettings.main_color}" @click="closePolicy"><small>{{ i18n.t('close') }}</small></b-link>
        </b-col>
      </b-card-header>
      <div class="col queue-policy-font">
        <PrivacyPolicy v-if="showPolicy === true" :locale="locale" />
        <TermsOfUse v-if="showTerms === true" :locale="locale" />
      </div>
    </b-card>
     <stripe-checkout
      ref="checkoutRef"
      :pk="publishableKey"
      :stripe-account="accountId"
      :session-id="sessionId"
    />
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BCard, BCardHeader, BBadge, BCalendar, BDropdown,
  BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BLink,
} from 'bootstrap-vue'
import { StripeCheckout } from '@vue-stripe/vue-stripe'
import { VueTelInput } from 'vue-tel-input'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  max, email, regex, required, likePhone, textNumSpaceDash,
} from '@/libs/validation/validations.js'
import i18n from '@/libs/i18n'
import {mapGetters, mapActions, mapMutations} from 'vuex'
import ShowError from '@/components/ShowError.vue'
import PrivacyPolicy from '@/components/policy/PrivacyPolicy.vue'
import TermsOfUse from '@/components/policy/TermsOfUse.vue'

export default {
  name: 'FormBooking',
  components: {
    StripeCheckout,
    ShowError,
    BCalendar,
    BDropdown,
    BRow,
    BCard,
    BCardHeader,
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BBadge,
    BFormTextarea,
    BFormCheckbox,
    BLink,
    VueTelInput,
    ValidationProvider,
    ValidationObserver,
    PrivacyPolicy,
    TermsOfUse,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
  },
  directives: {
    Ripple,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: {
    day: {
      type: String,
      required: true,
    },
    timeslot: {
      type: String,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
    workspace: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.setValueToForm()
    this.getTimeslotsAndCountdown()
  },
  data() {
    this.publishableKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY
    return {
      accountId: null,
      sessionId: null,
      services: [],
      name: '',
      phone: '',
      userEmail: '',
      date: '',
      showDate: '',
      minDate: new Date(),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 3)),
      time: '',
      totalTime: '',
      additionally: '',
      approved: false,
      loadingSetRecord: false,
      showForm: true,
      showPolicy: false,
      showTerms: false,
      loadingTime: false,
      phoneDropdownOptions: {
        showSearchBox: true,
        showFlags: true,
        showDialCodeInList: true,
        autoFormat: true,
        placeholder: 'Lorem',
      },
      canCloseCalendar: false,
      i18n,
      //validation
      required,
      max,
      email,
      regex,
      likePhone,
      textNumSpaceDash,
    }
  },
  computed: mapGetters(['getWidgetSettings', 'getErrorBookingStatus', 'getServices', 'getDayTimeslots', 'getCountdown', 'getCode']),
  methods: {
    ...mapActions(['setRecordLikeGuest', 'fetchDayTimeslotsAndCountdown', 'fetchPaymentLink']),
    ...mapMutations(['UPDATE_ERROR_BOOKING_STATUS', 'updateServiceStatusAvailable', 'UPDATE_CODE', 'REMOVE_TIME_FROM_ALL_TIMESLOTS', 'REMOVE_TIME_FROM_DAY_TIMESLOTS']),
    countryChanged(country) {
      if (this.getCode) {
        if (this.getCode !== country.iso2) {
          this.UPDATE_CODE(country.iso2)
        } return
      } this.UPDATE_CODE(country.iso2)
    },
    showServicesThisWorkspace(workspace) {
      const servicesThisWorkspace = []
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.getServices.length; i++) {
        // eslint-disable-next-line camelcase
        const service = this.getServices[i]
        const serviceId = service.workspaces_by_service.find(item => item === workspace)
        if (serviceId !== undefined) {
          servicesThisWorkspace.push(service)
        }
      }
      return servicesThisWorkspace
    },
    setShowDate(data) {
      this.showDate = data.selectedFormatted
    },
    changeDate() {
      this.canCloseCalendar = true
      this.updateTimeslots()
    },
    whenOpenCalendar() {
      this.canCloseCalendar = false
    },
    whenCloseCalendar(bvEvent) {
      if (!this.canCloseCalendar) {
        bvEvent.preventDefault()
      }
    },
    tapCloseCalendar() {
      this.canCloseCalendar = true
    },
    dateDisabledToCalendar(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      // const day = date.getDate()
      // Return `true` if the date should be disabled
      return !this.workspace.iso_weekday_ids.includes(weekday) || this.workspace.days_off_by_workspace.includes(ymd)
    },
    updateTimeslots() {
      this.getTimeslotsAndCountdown()
    },
    closePolicy() {
      this.showPolicy = this.showTerms = false
    },
    openPolicy() {
      this.showPolicy = !this.showPolicy
      this.showTerms = false
    },
    openTerms() {
      this.showTerms = !this.showTerms
      this.showPolicy = false
    },
    splitTime(time, now) {
      const t = time.split(':')
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...t) - new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
    },
    stringToDateTime(string, now) {
      const time = string.split(':')
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...time)
    },
    setTotalPrice(val) {
      this.total_price = 0
      if (val.length) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < val.length; i++) {
        // eslint-disable-next-line operator-assignment
          this.total_price = this.total_price + val[i].price
        }
      }
    },
    setTotalTimeSelectedServices(services) {
      let h = 0
      let m = 0
      if (services.length) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < services.length; i++) {
          const time = services[i].time.split(':')
          h += Number(time[0])
          m += Number(time[1])
        }
        if (m > 60) {
          const truncNumber = Math.trunc(m / 60)
          h += truncNumber
          m %= 60
        }
        return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + + m + ':00'
      }
      return '00:00:00'
    },
    stringTimeToBeautifulFormat(string) {
      // console.log('BeautifulFormat', string)
      if (string && string !== undefined) {
        const now = new Date()
        const date = this.stringToDateTime(string, now)
        const h = date.getHours()
        const m = date.getMinutes()
        return (h < 1 ? '' : h + `${i18n.t('short-hours')}`) + ' ' + (m < 1 ? '' : m + `${i18n.t('short-minutes')}`)
      }
      return ''
    },
    setAvailableService(services = []) {
      const now = new Date()
      const countdown = this.getCountdown ? this.splitTime(this.getCountdown, now) : 0
      let arrayIdSelectedServices = []
      let countdownWithoutServiceTime = countdown
      if ((services && services.join(',')) || '') {
        this.setTotalPrice(services)
        arrayIdSelectedServices = services.map(i => i.id)
        let totalTimeSelectedServices = this.setTotalTimeSelectedServices(services)
        this.totalTime = this.stringTimeToBeautifulFormat(totalTimeSelectedServices)
        totalTimeSelectedServices = this.splitTime(totalTimeSelectedServices, now)
        countdownWithoutServiceTime = countdown - totalTimeSelectedServices
      }
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (const i in this.getServices) {
        if (!arrayIdSelectedServices.includes(this.getServices[i].id)) {
          if (this.splitTime(this.getServices[i].time, now) > countdownWithoutServiceTime) {
            this.updateServiceStatusAvailable({ index: i, value: false })
          } else {
            this.updateServiceStatusAvailable({ index: i, value: true })
          }
        } else {
          this.updateServiceStatusAvailable({ index: i, value: true })
        }
      }
    },
    getTimeslotsAndCountdown() {
      this.loadingTime = true
      const data = {
        workspace: this.workspace.id,
        services: this.services ? this.services.map(i => i.id) : [],
        day: this.date,
        start_time: this.time ? this.time : null,
        record: null,
      }
      this.fetchDayTimeslotsAndCountdown(data).then(() => {
        if (!this.getDayTimeslots.includes(this.time)) {
          this.time = ''
        } else {
          this.setAvailableService(this.services)
        }
        setTimeout(() => {
          this.loadingTime = false
        }, 500)
      }).catch(error => {
        setTimeout(() => {
          this.loadingTime = false
        }, 500)
        console.error(error)
      })
    },
    validateRecordForm() {
      this.$refs.bookingPageRecordForm.validate()
        // eslint-disable-next-line consistent-return
        .then(success => {
          if (success) {
            this.loadingSetRecord = true
             const data = {
              start_time: this.time,
              start_day: this.date,
              workspace: this.workspace.id,
              name: this.name,
              email: this.userEmail,
              phone: this.phone.replace(/\s/g, ''),
              additionally: this.additionally,
              services: this.services.map(i => i.id),
            }
            this.setRecordLikeGuest(data).then(response => {
              this.finishOrPayment(response.data.id)
            }).catch(error => {
              this.loadingSetRecord = false
              if (error.response.status !== 400) {
                this.showForm = false
                this.approved = false
              } else {
                this.$refs.bookingPageRecordForm.setErrors(error.response.data)
              }
            })
            return true
          }
          return false
        })
    },
    getPaymentGateway() {
      if (this.workspace.payment_gateway) {
        return this.workspace.payment_gateway.id
      } if (this.getWidgetSettings.payment_gateway) {
        return this.getWidgetSettings.payment_gateway.id
      }
      return null
    },
    async finishOrPayment(idRecord) {
      const paymentGateway = await this.getPaymentGateway()
      if (paymentGateway) {
        // logic here
        this.fetchPaymentLink({ paymentGateway, idRecord }).then(response => {
          this.sessionId = response.session_id
          this.accountId = response.connected_account_id
          setTimeout(() => {
            this.$refs.checkoutRef.redirectToCheckout()
          }, 50)
          this.loadingSetRecord = false
        }).catch(() => {
          this.finishBooking(idRecord)
        })
      } else {
        this.finishBooking(idRecord)
      }
    },
    finishBooking(idRecord) {
      this.loadingSetRecord = false
      this.$refs.bookingPageRecordForm.reset()
      this.resetValue()
      this.showForm = false
      this.approved = false
      this.deleteTimeslot()
      this.goToTheWebsite(idRecord)
    },
    goToTheWebsite(id) {
      window.open(`${process.env.VUE_APP_DOMAIN_URL}/order/${id}`, '_self')
    },
    deleteTimeslot() {
      if (this.getWidgetSettings.timeslot_display_mode === 1) {
        const dateAndTime = {
          date: this.date,
          time: this.time,
        }
        this.REMOVE_TIME_FROM_ALL_TIMESLOTS(dateAndTime)
      } else {
        this.REMOVE_TIME_FROM_DAY_TIMESLOTS(this.time)
      }
    },
    closeModal() {
      if (this.getErrorBookingStatus) {
        this.UPDATE_ERROR_BOOKING_STATUS(false)
      }
      this.showForm = true
      this.$emit('close')
    },
    setValueToForm() {
      this.services = [this.service]
      this.date = this.day
      this.time = this.timeslot
    },
    resetValue() {
      this.name = ''
      this.phone = ''
      this.userEmail = ''
      this.services = []
      this.additionally = ''
    },
  },
}
</script>
<style>
</style>
